<template>
	<q-table :data="tableData"
			 :columns="columns"
			 :visible-columns="visibleColumns"
			 :pagination.sync="pagination"
			 :loading="loadingLogs"
			 :rows-per-page-options="rowsPerPageOptions"
			 :pagination-label="getPaginationLabel"
			 row-key="intLogId"
			 @request="onRequest"
			 class="sticky-header-table first-column-sticky"
			 ref="logTable"
	>
		<template v-slot:loading>
			<q-inner-loading showing color="primary"/>
		</template>
		<template v-slot:body="props">
			<veneer-log-table-row
          :props="props"
          :emit-log="emitLog"
          :show-active-watchlist-check="true"
          @click="(log) => $emit('click', log)"
      />
		</template>
	</q-table>
</template>

<script>
	import {logSearchPageSize} from "@/common/config";
	import LogSearchMixin from "@/mixins/LogSearchMixin";
	import VeneerLogTableRow from "@/components/common/VeneerLogTableRow";
	import {mapGetters} from "vuex";
	import {encodeGrade} from "@/mixins/GradeFilter";
  import TableMethods from "@/mixins/TableMethods";

	export default {
		name: "VeneerLogTable",
		components: {VeneerLogTableRow},
		mixins: [LogSearchMixin, TableMethods],
		props: ['logs', 'emitLog'],
		data() {
			return {
				visibleColumns: [
					'name', 'species', 'logArea', 'maxLength'
				],
				columns: [
					{name: 'name', label: this.$t('veneerLog'), field: 'strLogNo', align: 'left', required: true},
					{name: 'species', label: this.$t('species'), align: 'left', required: true},
					{name: 'logArea', label: `${this.$t('logArea')} (${this.$t('unit.sqm')})`, align: 'right', required: true},
          {name: 'resultAreaNotRemeasured', label: `${this.$t('packageArea')} (${this.$t('unit.sqm')})`, align: 'right'},
          {name: 'inLogPercentage', label: `${this.$t('inLogPercentage')} (${this.$t('unit.percentage')})`, align: 'right'},
          {name: 'measuredArea', label: `${this.$t('measuredArea')} (${this.$t('unit.sqm')})`, align: 'right'},
          {name: 'measuredAreaPercentage', label: `${this.$t('measuredArea')} (${this.$t('unit.percentage')})`, align: 'right'},
					{name: 'maxLength', label: `${this.$t('maxLength')} (${this.$t('unit.cm')})`, align: 'right', required: true},
					{name: 'quality', label: this.$t('quality'), align: 'left'},
					{name: 'structure', label: this.$t('structure'), align: 'left'},
					{name: 'grade', label: this.$t('grade'), align: 'left', field: row => encodeGrade(row.grade)},
					{name: 'palletNo', label: this.$t('palletNo'), align: 'left'},
					{name: 'place', label: this.$t('place'), align: 'left'},
					{name: 'characteristic', label: this.$t('characteristic'), align: 'left'},
					{name: 'thickness', label: `${this.$t('thickness')} (${this.$t('unit.mm')})`, align: 'right'},
					{name: 'internalQualityName', label: this.$t('internalQuality'), align: 'left'},
					{name: 'logInfo', label: this.$t('logInfo'), align: 'left'},
					{name: 'palletInfo', label: this.$t('palletInfo'), align: 'left'},
					{name: 'actions', label: '', align: 'right'}
				],
				pagination: {
					page: 1,
					rowsPerPage: logSearchPageSize,
					rowsNumber: 0
				},
				rowsPerPageOptions: [logSearchPageSize]
			}
		},
		mounted() {
			this.pagination.rowsNumber = this.logSearchResults.length + 1;

			if (!this.simplified) {
        this.addColumns(['quality', 'structure'])
			}

			if (this.user && !this.simplified) {
        this.addColumns(['grade', 'palletNo', 'place'])
			}

      this.addColumns(['characteristic', 'thickness'])

			if (this.user && !this.simplified) {
        this.addColumns(['internalQualityName', 'logInfo', 'palletInfo'])
			}

			this.addColumns(['actions']);
      this.toggleOptionalColumns();
		},
		watch: {
			logSearchResults(newResults, oldResults) {
				if (oldResults.length < newResults.length) {
					this.pagination.page = 1;
				}

				this.pagination.rowsNumber = newResults.length + 1;

        this.toggleOptionalColumns();
			}
		},
		computed: {
			...mapGetters(['user', 'watchlist']),
			tableData() {
				if(this.logs) {
					return this.logs;
				}

				return this.logSearchResults.slice(
					(this.pagination.page - 1) * logSearchPageSize,
					this.pagination.page * logSearchPageSize
				)
			},
			simplified() {
				return this.watchlist && this.isPublic ? this.watchlist.simplified : false;
			},
			// is public view reached through shared watchlist
			isPublic() {
				return this.$route.meta.hasOwnProperty('isPublic') && this.$route.meta.isPublic;
			},
		},
		methods: {
			async onRequest(props) {
				let {page, rowsPerPage, rowsNumber, sortBy, descending} = props.pagination;

				if (page * rowsPerPage > this.logSearchResults.length) {
					await this.loadAdditionalResults();
					// scroll back to top
					this.$refs.logTable.scrollTo(0);
				}

				this.pagination.page = page;
			},
			getPaginationLabel(firstRowIndex, endRowIndex, totalRowsNumber) {
				return '';
			},
      toggleOptionalColumns() {
        // adds columns if lengthFrom, widthFrom or widthTo filters are active
        this.toggleColumns(
            ['resultAreaNotRemeasured', 'inLogPercentage'],
            (
                this.logSearchParams.lengthFrom ||
                this.logSearchParams.widthFrom ||
                this.logSearchParams.widthTo
            ),
            this.columnPosition('logArea')
        )

        // adds columns if lengthMax filter is active
        let afterColumn = this.columnPosition('inLogPercentage');
        afterColumn = afterColumn > -1 ? afterColumn : this.columnPosition('logArea');
        this.toggleColumns(['measuredArea', 'measuredAreaPercentage'], (this.logSearchParams.lengthMax), afterColumn);
      }
		}
	}
</script>